<div class="traffic-log-list-expanded-content-summary">
    <!-- L7 log -->
    <ng-container *ngIf="(vsAppProfileType$ | async) === VsAppProfileType.L7">
        <!-- Client -->
        <div class="traffic-log-list-expanded-content-summary__column">
            <h7 class="traffic-log-list-expanded-content-summary__column-title">
                {{ globalL10nKeys.clientLabel | vtranslate }}
            </h7>
            <ng-container *ngrxLet="(applicationLog$ | async | l7ClientInfo) as clientInfo">
                <!-- User ID -->
                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ l10nKeys.userIdLabel | vtranslate }}
                    </div>
                    <span
                        *ngIf="clientInfo.user_id as userId; else na"
                        logFilter
                        property="user_id"
                        [value]="userId"
                    >
                        {{ userId }}
                    </span>
                </div>

                <!-- Location -->
                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ l10nKeys.locationLabel | vtranslate }}
                    </div>
                    <div
                        logNationalFlag
                        [countryCode]="clientInfo.client_location"
                    ></div>
                    <span
                        *ngIf="clientInfo.client_location as location; else na"
                        logFilter
                        [property]="'client_location'"
                        [value]="location"
                    >
                        {{ location | countryCodeToName }}
                    </span>
                </div>

                <!-- OS -->
                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ l10nKeys.operatingSystemLabel | vtranslate }}
                    </div>
                    <i
                        *ngIf="(clientInfo.client_os | logClientEnvToIconClass:'os') !== 'unknown'; else clrUnknownIcon"
                        class="icon-{{ clientInfo.client_os | logClientEnvToIconClass:'os' }}"
                    ></i>
                    <span
                        *ngIf="clientInfo.client_os as os; else na"
                        logFilter
                        [property]="'client_os'"
                        [value]="os"
                    >
                        {{ os }}
                    </span>
                </div>

                <!-- Device -->
                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ l10nKeys.deviceLabel | vtranslate }}
                    </div>
                    <cds-icon
                        *ngIf="(clientInfo.client_device | logClientEnvToIconClass:'device') === 'desktop'"
                        class="traffic-log-list-expanded-content-summary__clr-icon-with-margin-right"
                        shape="display"
                    ></cds-icon>
                    <cds-icon
                        *ngIf="(clientInfo.client_device | logClientEnvToIconClass:'device') === 'tablet'"
                        class="traffic-log-list-expanded-content-summary__clr-icon-with-margin-right"
                        shape="tablet"
                        size="14"
                    ></cds-icon>
                    <span
                        *ngIf="clientInfo.client_device as device; else na"
                        logFilter
                        [property]="'client_device'"
                        [value]="device"
                    >
                        {{ device }}
                    </span>
                </div>

                <!-- Perfect Forward Secrecy -->
                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ l10nKeys.perfectForwardSecrecyLabel | vtranslate }}
                    </div>
                    <span
                        *ngIf="clientInfo.pfs as pfs; else na"
                        logFilter
                        property="ssl_cipher"
                        [operator]="FilterOperatorType.CONTAINS"
                        [value]="pfs"
                    >
                        {{ pfs }}
                    </span>
                </div>

                <!-- Browser -->
                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ l10nKeys.browserLabel | vtranslate }}
                    </div>
                    <i
                        *ngIf="(clientInfo.client_browser | logClientEnvToIconClass:'device') !== 'globe'; else clrWorldIcon"
                        class="icon-{{ clientInfo.client_browser | logClientEnvToIconClass:'browser' }}"
                    ></i>
                    <span
                        *ngIf="clientInfo.client_browser as browser; else na"
                        logFilter
                        [property]="'client_browser'"
                        [value]="browser"
                    >
                        {{ browser }}
                    </span>
                </div>

                <!-- Start Time -->
                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ l10nKeys.startTimeLabel | vtranslate }}
                    </div>
                    <span *ngIf="clientInfo.startTime; else na">{{ clientInfo.startTime | aviDate:timeFormat }}</span>
                </div>

                <!-- End Time -->
                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ l10nKeys.endTimeLabel | vtranslate }}
                    </div>
                    <span *ngIf="clientInfo.endTime; else na">{{ clientInfo.endTime | aviDate:timeFormat }}</span>
                </div>
            </ng-container>
        </div>

        <!-- Avi + Rules and Policies -->
        <div class="traffic-log-list-expanded-content-summary__column">
            <h7 class="traffic-log-list-expanded-content-summary__column-title">
                {{ l10nKeys.vmwareAlbLabel | vtranslate }}
            </h7>

            <ng-container *ngrxLet="(applicationLog$ | async | nsxAlbInfo) as nsxAlbInfo">
                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ l10nKeys.requestIdLabel | vtranslate }}
                    </div>
                    <span
                        *ngIf="nsxAlbInfo.request_id; else na"
                        logFilter
                        property="request_id"
                        [value]="nsxAlbInfo.request_id"
                    >
                        {{ nsxAlbInfo.request_id }}
                    </span>
                </div>
                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ l10nKeys.redirectUriLabel | vtranslate }}
                    </div>
                    <span
                        *ngIf="nsxAlbInfo.redirected_uri as redirectedUri; else na"
                        logFilter
                        property="redirected_uri"
                        [value]="redirectedUri"
                    >
                        {{ redirectedUri }}
                    </span>
                </div>

                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ globalL10nKeys.responseLengthLabel | vtranslate }}
                    </div>
                    <span
                        *ngIf="nsxAlbInfo.response_length !== undefined; else na"
                        logFilterList
                        property="server_response_length"
                        [value]="nsxAlbInfo.response_length"
                    >
                        {{ nsxAlbInfo.response_length }} {{ globalL10nKeys.shortBytesLabel | vtranslate }}
                    </span>
                </div>
            </ng-container>

            <h7 class="traffic-log-list-expanded-content-summary__column-title">
                {{ l10nKeys.rulesAndPoliciesLabel | vtranslate }}
            </h7>
            <ng-container *ngrxLet="(applicationLog$ | async | policyRules) as policyRules">
                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ l10nKeys.persistenceIdLabel | vtranslate }}
                    </div>
                    <span
                        *ngIf="policyRules.persistent_session_id !== undefined; else na"
                        logFilter
                        property="persistent_session_id"
                        [value]="policyRules.persistent_session_id"
                    >
                        {{ policyRules.persistent_session_id }}
                    </span>
                </div>

                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ l10nKeys.virtualHostRuleNameLabel | vtranslate }}
                    </div>
                    <span
                        *ngIf="policyRules.vh_match_rule as rule; else na"
                        logPartialSelectionFilter
                        property="vh_match_rule"
                        [value]="rule"
                        position="right"
                    ></span>
                </div>

                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ l10nKeys.networkSecurityPolicyRuleLabel | vtranslate }}
                    </div>
                    <span
                        *ngIf="policyRules.networkSecurityPolicyRule as rule; else na"
                        logPartialSelectionFilter
                        property="network_security_policy_rule_name"
                        [value]="rule"
                        position="right"
                    ></span>
                </div>

                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ l10nKeys.httpSecurityPolicyRuleLabel | vtranslate }}
                    </div>
                    <span
                        *ngIf="policyRules.httpSecurityPolicyRule as rule; else na"
                        logPartialSelectionFilter
                        property="http_security_policy_rule_name"
                        [value]="rule"
                        position="right"
                    ></span>
                </div>

                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ l10nKeys.httpRequestPolicyRuleLabel | vtranslate }}
                    </div>
                    <span
                        *ngIf="policyRules.httpRequestPolicyRule as rule; else na"
                        logPartialSelectionFilter
                        property="http_request_policy_rule_name"
                        [value]="rule"
                        position="right"
                    ></span>
                </div>

                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ l10nKeys.httpResponsePolicyRuleLabel | vtranslate }}
                    </div>
                    <ng-container >
                        <span
                            *ngIf="policyRules.httpResponsePolicyRule as rule; else na"
                            logPartialSelectionFilter
                            property="http_response_policy_rule_name"
                            [value]="rule"
                            position="right"
                        ></span>
                    </ng-container>
                </div>
            </ng-container>
            <log-policy-grid
                [ssl]="ssl$ | async"
                [hasAuthenticationLogs]="hasAuthenticationLogs$ | async"
                [icapLog]="icapLog$ | async"
                [wafLog]="wafLog$ | async"
                [botManagementLog]="botManagementLog$ | async"
                [datascriptInfo]="datascriptInfo$ | async"
                [compactMode]="true"
            ></log-policy-grid>
        </div>

        <!-- Client Request Info & Server Response Infomation -->
        <div class="traffic-log-list-expanded-content-summary__column">
            <!-- Client Request Infomation -->
            <h7 class="traffic-log-list-expanded-content-summary__column-title">
                {{ l10nKeys.clientRequestInfoLabel | vtranslate }}
            </h7>
            <ng-container *ngrxLet="(applicationLog$ | async | requestInfo) as requestInfo">
                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ globalL10nKeys.hostLabel | vtranslate }}
                    </div>
                    <span
                        *ngIf="requestInfo.host; else na"
                        logPartialSelectionFilter
                        [property]="'host'"
                        [value]="requestInfo.host"
                        position="right"
                    ></span>
                </div>

                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ globalL10nKeys.requestLabel | vtranslate }}
                    </div>
                    <ng-container *ngIf="(applicationLog$ | async | requestDetails) as requestDetails; else na">
                        <span
                            *ngIf="requestDetails.method as method"
                            logFilter
                            property="method"
                            [value]="method"
                        >
                            {{ method }}
                        </span>

                        <span
                            *ngIf="requestDetails.http_version as httpVersion"
                            logFilter
                            property="http_version"
                            [value]="httpVersion"
                        >
                            {{ httpVersion | logHttpVersion }}
                        </span>

                        <ng-container *ngIf="requestDetails.request_length !== undefined">
                            (<span
                                logFilterList
                                property="request_length"
                                [value]="requestDetails.request_length"
                            >
                                {{ requestDetails.request_length }} {{ globalL10nKeys.shortBytesLabel | vtranslate }}
                            </span>)
                        </ng-container>

                        <span
                            *ngIf="requestDetails.request_content_type as contentType"
                            logPartialSelectionFilter
                            property="request_content_type"
                            [value]="contentType"
                        ></span>
                    </ng-container>
                </div>

                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ l10nKeys.unparsedUriLabel | vtranslate }}
                    </div>
                    <span
                        *ngIf="requestInfo.orig_uri as uri; else na"
                        logPartialSelectionFilter
                        property="orig_uri"
                        [value]="uri"
                        position="right"
                    ></span>
                </div>

                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ l10nKeys.uriLabel | vtranslate }}
                    </div>
                    <span
                        *ngIf="requestInfo.uri as uri; else na"
                        logPartialSelectionFilter
                        property="uri_path"
                        [value]="uri"
                        [noSearchIcon]="!!requestInfo.uriQuery"
                        position="right"
                    ></span>
                    <ng-container *ngIf="requestInfo.uriQuery as uriQuery">
                        <span class="traffic-log-list-expanded-content-summary__uri-query-question-mark">
                            &nbsp;?&nbsp;
                        </span>
                        <span
                            logPartialSelectionFilter
                            property="uri_query"
                            [value]="uriQuery"
                            position="right"
                        ></span>
                    </ng-container>
                </div>

                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ l10nKeys.userAgentLabel | vtranslate }}
                    </div>
                    <span
                        *ngIf="requestInfo.userAgent; else na"
                        logPartialSelectionFilter
                        property="user_agent"
                        [value]="requestInfo.userAgent"
                        position="right"
                    ></span>
                </div>
            </ng-container>

            <!-- Server Response Information -->
            <h7 class="traffic-log-list-expanded-content-summary__column-title">
                {{ l10nKeys.serverResponseInfoLabel | vtranslate }}
            </h7>
            <ng-container *ngrxLet="(applicationLog$ | async | responseInfo) as responseInfo">
                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ l10nKeys.contentTypeLabel | vtranslate }}
                    </div>
                    <span
                        *ngIf="responseInfo.response_content_type as contentType; else na"
                        logPartialSelectionFilter
                        property="response_content_type"
                        [value]="contentType"
                        position="right"
                    ></span>
                </div>

                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ l10nKeys.serverRedirectUriLabel | vtranslate }}
                    </div>
                    <span
                        *ngIf="responseInfo.server_side_redirect_uri as redirectedUri; else na"
                        logFilter
                        property="server_side_redirect_uri"
                        [value]="redirectedUri"
                    >
                        {{ redirectedUri }}
                    </span>
                </div>

                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ l10nKeys.serverResponseLengthLabel | vtranslate }}
                    </div>
                    <span
                        *ngIf="responseInfo.serverResponseLength !== undefined; else na"
                        logFilter
                        property="server_response_length"
                        [value]="responseInfo.serverResponseLength"
                    >
                        {{ responseInfo.serverResponseLength }} {{ globalL10nKeys.shortBytesLabel | vtranslate }}
                    </span>
                </div>

                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ l10nKeys.grpcStatusLabel | vtranslate }}
                    </div>
                    <ng-container *ngIf="responseInfo.grpcStatus !== undefined; else na">
                        <span
                            logFilter
                            [property]="'grpc_status'"
                            [value]="responseInfo.grpcStatus"
                        >
                            {{ responseInfo.grpcStatus }}
                        </span>
                    </ng-container>
                </div>
            </ng-container>
        </div>
    </ng-container>

    <!-- L4 log -->
    <ng-container *ngIf="(vsAppProfileType$ | async) === VsAppProfileType.L4">
        <!-- Location -->
        <div class="traffic-log-list-expanded-content-summary__column">
            <ng-container *ngrxLet="(connectionLog$ | async | l4ClientInfo) as clientInfo">
                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [withMarginTop]="false"
                        [inline]="true"
                    >
                        {{ l10nKeys.locationLabel | vtranslate }}
                    </div>
                    <div
                        logNationalFlag
                        [countryCode]="clientInfo.client_location"
                    ></div>
                    <span
                        *ngIf="clientInfo.client_location as location; else na"
                        logFilter
                        property="client_location"
                        [value]="location"
                    >
                        {{ location | countryCodeToName }}
                    </span>
                </div>

                <!-- Start Time -->
                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ l10nKeys.startTimeLabel | vtranslate }}
                    </div>
                    <span *ngIf="clientInfo.startTime; else na">{{ clientInfo.startTime | aviDate:timeFormat }}</span>
                </div>

                    <!-- End Time -->
                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ l10nKeys.endTimeLabel | vtranslate }}
                    </div>
                    <span *ngIf="clientInfo.endTime; else na">{{ clientInfo.endTime | aviDate:timeFormat }}</span>
                </div>
            </ng-container>
        </div>
    </ng-container>

    <!-- DNS log -->
    <ng-container *ngIf="(vsAppProfileType$ | async) === VsAppProfileType.DNS">
        <!-- Two Client columns -->
        <ng-container *ngrxLet="(connectionLog$ | async | dnsClientInfo) as clientInfo">
            <div class="traffic-log-list-expanded-content-summary__column">
                <h7 class="traffic-log-list-expanded-content-summary__column-title">
                    {{ globalL10nKeys.clientLabel | vtranslate }}
                </h7>

                <!-- Location -->
                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ l10nKeys.locationLabel | vtranslate }}
                    </div>
                    <div
                        logNationalFlag
                        [countryCode]="clientInfo.client_location"
                    ></div>
                    <span
                        *ngIf="clientInfo.client_location as location; else na"
                        logFilter
                        property="client_location"
                        [value]="location"
                    >
                        {{ location | countryCodeToName }}
                    </span>
                </div>

                <!-- Start Time -->
                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ l10nKeys.startTimeLabel | vtranslate }}
                    </div>
                    <span *ngIf="clientInfo.startTime; else na">{{ clientInfo.startTime | aviDate:timeFormat }}</span>
                </div>

                <!-- End Time -->
                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ l10nKeys.endTimeLabel | vtranslate }}
                    </div>
                    <span *ngIf="clientInfo.endTime; else na">{{ clientInfo.endTime | aviDate:timeFormat }}</span>
                </div>
            </div>

            <!-- DNS Query Type -->
            <div
                class="traffic-log-list-expanded-content-summary__column"
                [withDivider]="false"
                [withContentTopPadding]="true"
            >
                <h7 class="traffic-log-list-expanded-content-summary__column-title">
                    <!-- blank placeholder for alignment -->
                    &nbsp;
                </h7>
                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ l10nKeys.dnsQueryTypeLabel | vtranslate }}
                    </div>
                    <span
                        *ngIf="clientInfo.dns_qtype as queryType; else na"
                        logFilter
                        property="dns_qtype"
                        [value]="queryType"
                    >
                        {{ queryType | enumValueLabel: 'DnsRecordType' }}
                    </span>
                </div>

                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ globalL10nKeys.protocolLabel | vtranslate }}
                    </div>
                    <span
                        *ngIf="clientInfo.protocol as protocol; else na"
                        logFilter
                        property="protocol"
                        [value]="protocol"
                    >
                        {{ protocol | enumValueLabel: 'Protocol' }}
                    </span>
                </div>

                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ l10nKeys.seClosedTcpConnectionLabel | vtranslate }}
                    </div>
                    <span
                        *ngIf="clientInfo.dns_tcp_conn_close_from_se as se_closed_tcp_connection; else na"
                        logFilter
                        property="dns_tcp_conn_close_from_se"
                        [value]="se_closed_tcp_connection"
                    >
                        {{ se_closed_tcp_connection }}
                    </span>
                </div>
            </div>
        </ng-container>

        <!-- Load Balancer column -->
        <div class="traffic-log-list-expanded-content-summary__column">
            <h7 class="traffic-log-list-expanded-content-summary__column-title">
                {{ globalL10nKeys.loadBalancerLabel | vtranslate }}
            </h7>

            <ng-container *ngrxLet="(connectionLog$ | async | dnsLoadBalancerInfo) as dnsLoadBalancerInfo">
                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ l10nKeys.gslbServiceLabel | vtranslate }}
                    </div>
                    <span
                        *ngIf="dnsLoadBalancerInfo.gslbservice as gslbservice; else na"
                        logFilter
                        property="gslbservice"
                        [value]="gslbservice"
                    >
                        {{ gslbservice }}
                    </span>
                </div>

                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ l10nKeys.gslbPoolLabel | vtranslate }}
                    </div>
                    <div
                        *ngIf="dnsLoadBalancerInfo.gslbpool_name as gslbPoolName; else na"
                        logFilter
                        property="gslbpool_name"
                        [value]="gslbPoolName"
                    >
                        {{ gslbPoolName }}
                    </div>
                </div>

                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ globalL10nKeys.queryLabel | vtranslate }}
                    </div>
                    <span
                        *ngIf="dnsLoadBalancerInfo.query_or_response !== undefined; else na"
                        logFilter
                        property="query_or_response"
                        [value]="dnsLoadBalancerInfo.query_or_response"
                    >
                        {{ dnsLoadBalancerInfo.query_or_response }}
                    </span>
                </div>

                <div class="traffic-log-list-expanded-content-summary__column-item">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ l10nKeys.recursionAvailableLabel | vtranslate }}
                    </div>
                    <span
                        *ngIf="dnsLoadBalancerInfo.recursion_available !== undefined; else na"
                        logFilter
                        property="dns_response.recursion_available"
                        [value]="dnsLoadBalancerInfo.recursion_available"
                    >
                        {{ dnsLoadBalancerInfo.recursion_available }}
                    </span>
                </div>
            </ng-container>
        </div>
    </ng-container>
</div>

<ng-template #na>
    <span logEmptyField></span>
</ng-template>

<ng-template #clrUnknownIcon>
    <cds-icon shape="unknown-status"></cds-icon>
</ng-template>

<ng-template #clrWorldIcon>
    <cds-icon
        class="traffic-log-list-expanded-content-summary__clr-icon-with-margin-right"
        shape="world"
    ></cds-icon>
</ng-template>
